export const animateGridItem = selector => {
  if (window.Shopify.designMode === true) return;

  import(flu.chunks.anime).then(({ anime }) => {
    anime({
      targets: selector,
      translateY: [60, 0],
      opacity: 1,
      easing: "cubicBezier(.5, .05, .1, .3)",
      duration: 400,
      delay: anime.stagger(200),
    });
  });
};
